<template>
	<v-app-bar flat :height="56 + safeArea.top" class="nav-top-bar">
		<div class="nav-top-bar__brand">
			<template v-if="onApp">
				<img v-if="nav.customer.logo" :src="nav.customer.logo" :alt="nav.customer.name" class="nav-top-bar__customer-logo" />
			</template>
			<template v-else>
				<img src="/m.eagle/img/portal/logo-color.png" alt="eCOS" class="nav-top-bar__logo" />
				<span class="nav-top-bar__version">v{{ nav.version }}</span>
				<template v-if="nav.customer.logo">
					<v-divider vertical length="28" class="nav-top-bar__divider" />
					<img :src="nav.customer.logo" :alt="nav.customer.name" class="nav-top-bar__customer-logo" />
				</template>
			</template>
		</div>

		<v-spacer />

		<div class="nav-top-bar__actions">
			<v-btn icon variant="text" color="success" :title="t(nav.online ? 'Online' : 'Offline')" :aria-label="t(nav.online ? 'Online' : 'Offline')" :class="{ 'nav-top-bar__offline': !nav.online }" @click="emit('action', 'toggleOffline')">
				<v-icon>{{ nav.online ? 'wifi' : 'wifi_off' }}</v-icon>
			</v-btn>
			<v-btn v-if="nav.isLocalhost" icon variant="text" title="Vider le cache m.eagle" aria-label="Vider le cache m.eagle" @click="emit('action', 'clearLegacyAppCache')">
				<v-icon>delete_sweep</v-icon>
			</v-btn>
			<v-btn v-if="nav.updateReady" icon variant="tonal" color="primary" :title="t('UpdateReadyToInstallText')" :aria-label="t('UpdateReadyToInstallText')" @click="emit('action', 'installUpdate')">
				<v-icon>refresh</v-icon>
			</v-btn>
			<v-btn v-if="nav.extensionUpdate" icon variant="text" :title="t('UpdateNeeded')" :aria-label="t('UpdateNeeded')" @click="emit('action', 'extensionUpdate')">
				<v-badge icon="extension" color="secondary">
					<v-icon>refresh</v-icon>
				</v-badge>
			</v-btn>

			<v-btn v-for="key in panelKeys" :key="key" icon variant="text" :active="panel === key" :title="t(NAV_PANELS[key].labelKey)" :aria-label="t(NAV_PANELS[key].labelKey)">
				<v-badge :model-value="counts[key] > 0" :content="counts[key]" color="secondary">
					<v-icon>{{ NAV_PANELS[key].icon }}</v-icon>
				</v-badge>
				<v-menu activator="parent" :model-value="panel === key" location="bottom end" offset="8" :close-on-content-click="false" max-height="75vh" width="400" @update:model-value="(open) => setPanel(key, open)">
					<component :is="NAV_PANELS[key].component" @close="panel = null" />
				</v-menu>
			</v-btn>

			<v-btn icon variant="text" :title="t('Help')" :aria-label="t('Help')" @click="emit('action', 'help')">
				<v-icon>help</v-icon>
			</v-btn>
			<NavUserMenu :user-name="userName" :user-login="nav.user.userName" :delegation="nav.delegation" :on-app="onApp" :extension-update="nav.extensionUpdate" :points="points.available ? points.total : null" :widget-settings="nav.vueWidgets" :synchronizing="nav.synchronizing" @action="emit('action', $event)" />
		</div>
	</v-app-bar>
</template>

<script setup>
import { computed } from 'vue';
import NavUserMenu from './NavUserMenu.vue';
import { NAV_PANELS, DESKTOP_PANEL_ORDER } from './navPanels';
import { useAppChrome } from '@/composables/useAppChrome';
import { usePointsSummary } from '@/composables/usePointsSummary';
import { useTranslator } from '@/composables/useTranslator';

const emit = defineEmits(['action']);
const panel = defineModel('panel', { type: String, default: null });

const t = useTranslator();
const { nav, onApp, safeArea, counts, panels, userName, color } = useAppChrome();
const points = usePointsSummary();

const panelKeys = computed(() => DESKTOP_PANEL_ORDER.filter((key) => panels.value.includes(key)));

const setPanel = (key, open) => {
	if (open) panel.value = key;
	else if (panel.value === key) panel.value = null;
};
</script>
